import { z } from "zod";
import { PaymentStatus } from "@/gql/graphql";
import { createRoute } from "@tanstack/react-router";
import { PaymentDetailScreen } from "@/app/Payments/Screens/PaymentDetailScreen";
import { PaymentRecordScreen } from "@/app/Payments/Screens/PaymentRecordScreen";
import { PaymentListScreen } from "@/app/Payments/Screens/PaymentListScreen";
import { getPaymentListQueryVariables } from "@/app/Payments/Utils/getPaymentListQueryVariables";
import { paymentListQuery } from "@/app/Payments/GraphQL/paymentListQuery";
import {
  fetchQuery,
  prefetchInfiniteQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { paymentRecordQuery } from "@/app/Payments/GraphQL/paymentRecordQuery";
import { appLayoutRoute } from "@/routes/layout-routes";

const paymentSearchParams = z.object({
  paymentStatus: z
    .array(z.nativeEnum(PaymentStatus))
    .optional()
    .catch(undefined),
  paymentSearch: z.string().optional(),
});
export type PaymentListSearchParams = z.infer<typeof paymentSearchParams>;
export const paymentListRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/payments",
  component: PaymentListScreen,
  validateSearch: paymentSearchParams,
  loaderDeps: ({ search }) => search,
  loader: ({ deps, params }) => {
    return prefetchInfiniteQuery(
      paymentListQuery,
      getPaymentListQueryVariables(deps),
      params.orgId,
    );
  },
  head: () => ({
    meta: [
      {
        title: "Payments - Imoova Admin",
      },
      {
        name: "description",
        content: "Manage payments",
      },
    ],
  }),
});
export const paymentRoute = createRoute({
  getParentRoute: () => paymentListRoute,
  path: "$id",
  component: PaymentRecordScreen,
  loader: ({ params }) => {
    return fetchQuery(paymentRecordQuery, { id: params.id }, params.orgId);
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: `Payment #${loaderData?.payment.id ?? ""} - Imoova Admin`,
      },
    ],
  }),
});
export const paymentDetailRoute = createRoute({
  getParentRoute: () => paymentRoute,
  path: "/",
  component: PaymentDetailScreen,
});
